var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPen2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.568 1.97188L11.1581 0.451355C10.5998 -0.149918 9.62692 -0.150985 9.06869 0.451355L1.45154 8.66164L0.401411 12.8119L0.144569 13.0888C-0.0474433 13.2958 -0.0479384 13.6297 0.1416 13.8383L0.139127 13.849L0.148528 13.8463C0.244534 13.9482 0.369244 14 0.494448 14C0.621136 14 0.747825 13.9477 0.844327 13.8437L1.10166 13.5668L4.95082 12.4357L12.568 4.22438C13.144 3.60337 13.144 2.59289 12.568 1.97188ZM2.59471 8.93906L7.66423 3.47479L9.7635 5.73903L4.69398 11.2028L2.59471 8.93906ZM2.14783 9.96608L3.74134 11.6845L1.55002 12.3285L2.14783 9.96608ZM11.8682 3.46946L10.4633 4.98411L8.36399 2.71987L9.76895 1.20521C9.95304 1.00621 10.2742 1.00621 10.4583 1.20521L11.8682 2.72573C12.0582 2.93114 12.0582 3.26512 11.8682 3.46946Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPen2);
export default ForwardRef;